import { Box } from '@mui/material'
import { useMemo } from 'react'
import { VolumeProjectionTableProps } from './VolumeProjection.types'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import { GridColDef } from '@mui/x-data-grid-premium'

const staticColumns = new Set([
  'plannedVersion',
  'workCentreCode',
  'baseSourceSiteKey',
  'skuCode',
  'cycleTime',
  'replenishmentTypeCode',
  'minimumProductionOrderQuantity',
  'skuKey',
  'workCentreKey',
  'id',
])

export const VolumeProjectionMUITable = ({
  data,
  isLoading,
  skuCodes,
  cycleTime,
  plannedVersion,
  replenishmentType,
  workcentreCode,
  workcentreKey,
}: VolumeProjectionTableProps) => {
  const columns: ExtendedGridColDef[] = useMemo(() => {
    const c = [
      {
        headerName: 'Plan version',
        field: 'plannedVersion',
        width: 150,
        type: 'string',
      },
      {
        headerName: 'Source workcentre code',
        field: 'workCentreCode',
        width: 150,
        type: 'string',
      },
      {
        headerName: 'Source site',
        field: 'baseSourceSiteKey',
        width: 150,
        type: 'string',
      },
      {
        headerName: 'SKU code',
        field: 'skuCode',
        width: 150,
        type: 'string',
      },
      {
        headerName: 'Cycle',
        field: 'cycleTime',
        width: 150,
        type: 'number',
      },
      {
        headerName: 'Replenishment type',
        field: 'replenishmentTypeCode',
        width: 150,
        type: 'string',
      },
      {
        headerName: 'MOQ',
        field: 'minimumProductionOrderQuantity',
        width: 150,
        type: 'number',
      },
    ]

    const [firstRow] = data ?? {}
    let dynamicCols: GridColDef[] = []
    if (firstRow) {
      const cols = Object.keys(firstRow)
      if (cols && cols.length > 0) {
        dynamicCols = cols
          .filter((key: string) => !staticColumns.has(key))
          .map((key: string) => ({
            headerName: key,
            field: key,
            type: 'number',
          }))
      }
    }
    return [...c, ...dynamicCols]
  }, [
    data,
    skuCodes,
    cycleTime,
    plannedVersion,
    replenishmentType,
    workcentreCode,
    workcentreKey,
  ])

  // No-op functions for BaseTable required props (read-only table)
  const updateTableData = () => {
    // This is a read-only table, no updates needed
  }

  const uploadData = () => {
    // No upload functionality needed
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        maxWidth: 'calc(100vw - 70px)',
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadData={uploadData}
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={true}
        downloadFileName="VolumeProjectionData"
        getRowId={(row) => row.id}
      />
    </Box>
  )
}
